export default [{
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_1.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_2.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_3.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_4.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_5.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_6.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_7.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_8.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_9.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_10.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_11.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_12.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_13.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_14.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_15.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_16.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_17.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_18.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_19.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_20.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_21.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_22.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_23.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_24.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_25.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_26.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_27.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_28.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_29.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_30.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_31.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_32.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_33.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_34.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_35.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_36.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_37.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_38.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_39.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_40.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_41.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_42.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_43.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_44.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_45.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_46.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_47.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_48.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_49.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_50.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_51.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_52.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_53.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_54.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_55.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_56.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_57.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_58.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_59.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_60.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_61.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_62.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_63.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_64.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_65.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_66.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_67.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/7jie/7jie_68.jpg"
}]


// WEBPACK FOOTER //
// ./src/pages/history/jie7.js